import type { SalonItemContentProps } from "./types";
import { getSalonDisplayText } from "./utils";

export function SalonItemContent({
  salon,
  group,
  showFranchiseName = true,
}: SalonItemContentProps) {
  const franchiseHasMultipleSalons = group.franchise && group.salons.length > 1;
  const displayData = getSalonDisplayText(salon, franchiseHasMultipleSalons);

  if (displayData.isMultiLine && showFranchiseName) {
    return (
      <div className="flex flex-col">
        <div className="text-sm leading-tight whitespace-normal break-words">
          {displayData.franchiseName}
        </div>
        <div className="text-xs text-muted-foreground leading-tight whitespace-normal break-words">
          {displayData.salonName}
          {displayData.location && ` • ${displayData.location}`}
        </div>
      </div>
    );
  }

  // When franchise name is shown as section header, just show salon name + location
  if (displayData.isMultiLine && !showFranchiseName) {
    return (
      <div className="flex flex-col">
        <div className="text-sm leading-tight whitespace-normal break-words">
          {displayData.salonName}
        </div>
        {displayData.location && (
          <div className="text-xs text-muted-foreground whitespace-normal break-words">
            {displayData.location}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="text-left leading-tight whitespace-normal break-words">{displayData.text}</div>
  );
}
